module.exports = __webpack_public_path__ + "static/media/icon-servicos.ec964871.svg";